import { Container } from "basis";
import { FC } from "react";
import { Footer } from "../Footer/Footer";
import { NewsBanner } from "../NewsBanner/NewsBanner";
import { UnsupportedBrowserBanner } from "../UnsupportedBrowserBanner/UnsupportedBrowserBanner";
import { Callouts } from "./Callouts/Callouts";
import { FAQ } from "./FAQ/FAQ";
import styles from "./homepage.module.scss";
import { HomePageHeader } from "./HomePageHeader";
import { LoginSection } from "./LoginSection";
import { Promotion } from "./Promotion/Promotion";

export const HomePageComponent: FC<{}> = () => (
  <div className={styles.wrapper}>
    <div className={`${styles.headerLoginWrapper} ${styles.wrapper}`}>
      <HomePageHeader />
      <Container width="100%">
        <UnsupportedBrowserBanner />
        <NewsBanner />
      </Container>
      <LoginSection />
      <Promotion />
      <Callouts />
      <FAQ />
      <Footer />
    </div>
  </div>
);
